import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RxdbPointsViewComponent } from "./rxdb-points-view/rxdb-points-view.component";
import { RxdbBuildingsViewComponent } from "./rxdb-buildings-view/rxdb-buildings-view.component";
import { RxdbPathsViewComponent } from "./rxdb-paths-view/rxdb-paths-view.component";
import { RxdbWaypointsViewComponent } from "./rxdb-waypoints-view/rxdb-waypoints-view.component";
import { PointAuditComponent } from "./audit-view/point-audit.component";
import { RouterModule } from "@angular/router";
import { NgPipesModule } from "ngx-pipes";
import { SharedModule } from "../shared/shared.module";
import { CoreModule } from "../core/core.module";
import { ScoutModule } from "../scout/scout.module";
import { AccordionModule } from "ngx-bootstrap/accordion";
import { RxdbBuildingsEditComponent } from "./rxdb-buildings-edit/rxdb-buildings-edit.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RxdbPointsEditComponent } from "./rxdb-points-edit/rxdb-points-edit.component";
import { RxdbPathsEditComponent } from "./rxdb-paths-edit/rxdb-paths-edit.component";
import { RxdbWaypointsEditComponent } from "./rxdb-waypoints-edit/rxdb-waypoints-edit.component";
import { RxdbMarketsViewComponent } from "./rxdb-markets-view/rxdb-markets-view.component";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { MarketEditComponent } from "./market-edit/market-edit.component";
@NgModule({
  declarations: [
    RxdbPointsViewComponent,
    RxdbBuildingsViewComponent,
    RxdbPathsViewComponent,
    RxdbWaypointsViewComponent,
    PointAuditComponent,
    RxdbBuildingsEditComponent,
    RxdbPointsEditComponent,
    RxdbPathsEditComponent,
    RxdbWaypointsEditComponent,
    RxdbMarketsViewComponent,
    MarketEditComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    NgPipesModule,
    SharedModule,
    CoreModule,
    ScoutModule,
    AccordionModule,
    BsDropdownModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  exports: [
    RxdbPointsViewComponent,
    RxdbBuildingsViewComponent,
    RxdbPathsViewComponent,
    RxdbWaypointsViewComponent,
    PointAuditComponent,
    RxdbMarketsViewComponent,
    RxdbMarketsViewComponent,
  ],
})
export class OneSourceModule {}
